import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useSubmitGateway } from "../../lib/queries/queriesAndMutations";
import { gatewaySchema } from "../../lib/validation";
import Hint from "../main/Hint";
import Loader from "../shared/Loader";
import { CustomInput } from "../ui";
import RegexCustomInput from "../ui/RegexCustomInput";
import TextArea from "../ui/TextArea";
import ControlSelect from "./../ui/ControlSelect";

export default function GatewayForm() {
  const {
    control,
    register,
    handleSubmit,
    setError,
    setValue,
    clearErrors,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(gatewaySchema),
    defaultValues: {
      website_fa: "",
      website_en: "",
      field: "",
      gatewayType: "https",
      gatewayAddress: "",
    },
  });

  const navigate = useNavigate();

  const type = useSelector((store) => store.bussinessSlice.type);
  const bussinessId = useSelector((store) => store.bussinessSlice.data?.business?.id);

  const { mutateAsync: submitGateway, isPending } = useSubmitGateway();

  const handleBack = (e) => {
    e.preventDefault();
    navigate("/gateway/list");
  };
  const processForm = async (data) => {
    ////console.log(data, "gateway");
    const body = {
      website_fa: data.website_fa,
      website_en: data.website_en,
      field: data.field,
      description: data.description,
      domain: data.gatewayType + "://" + data.gatewayAddress,
      realbusiness_id: bussinessId,
    };
    try {
      const response = await submitGateway(body);
      if (response.status === 200) {
        toast.success(" درگاه با موفقیت ثبت گردید");
        navigate(`/gateway/list/`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className=" flex flex-col  gap-4 items-center justify-center py-4 ">
      <div className="max-w-[1000px] md:min-w-[740px] flex  flex-col gap-1 md:gap-6 mx-auto bg-white p-6 rounded-[24px]">
        <p className="text-lg  font-semibold">ایجاد درگاه جدید</p>
        <hr />
        <form onSubmit={handleSubmit(processForm)} className={`grid grid-cols-2 w-full gap-2   `}>
          <RegexCustomInput
            control={control}
            setValue={setValue}
            setError={setError}
            clearErrors={clearErrors}
            name={"website_fa"}
            label={"نام سایت به فارسی"}
            placeholder={"مثلا ونداپرداخت"}
            type={"text"}
            errors={errors.website_fa}
            className={""}
            regexPattern={/^[\u0600-\u06FF\s0-9]+$/}
            errorMessage={"فقط کاراکتر فارسی مجاز است"}
          />
          <RegexCustomInput
            control={control}
            setValue={setValue}
            setError={setError}
            clearErrors={clearErrors}
            name={"website_en"}
            label={"نام سایت به انگلیسی"}
            placeholder={"مثلا vandapardakht"}
            type={"text"}
            errors={errors.website_en}
            className={"font-sans"}
            regexPattern={/^[a-zA-Z0-9?><;,{}[\]\-_+=!@#$%^&*|' ]*$/}
            errorMessage={"فقط کاراکتر انگلیسی مجاز است"}
          />

          <CustomInput
            control={control}
            name={"field"}
            label={"حوره فعالیت"}
            placeholder={"مثلا فروش کالاهای دیجیتال"}
            type={"text"}
            errors={errors.field}
            className={"col-span-2 xl:col-span-2 "}
          />
          <div className="flex flex-col col-span-2">
            <label htmlFor="">آدرس دامنه سایت</label>
            <div className="gap-2 flex justify-center items-start ">
              <CustomInput
                control={control}
                name={"gatewayAddress"}
                label={""}
                placeholder={"مثلاvandapardakht.ir"}
                type={"text"}
                errors={errors.gatewayAddress}
                className={"col-span-2 flex-1 "}
              />

              <ControlSelect
                className={"w-[100px] md:min-w-[185px]"}
                control={control}
                name={"gatewayType"}
                label={""}
                errors={errors.gatewayType}
                hidden={true}
                options={[
                  { id: "1", value: "http", title: "http" },
                  { id: "2", value: "https", title: "https" },
                ]}
              />
            </div>
          </div>

          <TextArea
            register={register}
            name={"description"}
            label={"توضیحات"}
            placeholder={""}
            type={"text"}
            errors={errors.description}
            className={"col-span-2 xl:col-span-2"}
          />

          <div className="flex gap-2 self-end col-span-2 justify-end">
            <button onClick={handleBack} className="btn-cancel ">
              انصراف
            </button>
            <button type="submit" className="btn-container disabled:bg-slate-500  " disabled={isPending}>
              {isSubmitting || isPending ? (
                <div className="flex gap-4 items-center">
                  <p className="text-xs">در حال ارسال</p>
                  <div className="flex-center gap-2 w-6 h-full ">
                    <Loader />
                  </div>
                </div>
              ) : (
                <p>ساخت درگاه</p>
              )}
            </button>
          </div>
        </form>
      </div>
      <div className=" hidden md:flex-1 ">
        <Hint
          hintStyle={"entry"}
          response={"mobile"}
          hintImage={true}
          title={"راهنما"}
          entry={""}
          imagestyle={"desktop"}
        >
          <ul>
            <li className="text-title-sm-regular mb-4">
              در صورتی که به صورت حقیقی (یا حقوقی) در ونداپرداخت ثبت کسب‌وکار می‌کنید، شبای شما باید متصل به
              حساب کسب‌وکار حقیقی (یا حقوقی) شما باشد.
            </li>
            <li className="text-title-sm-regular">
              طبق اعلامیه شاپرک، صاحب حسابی که شماره‌شبا آن را وارد می‌نمایید باید با دارنده کدملی و مالک
              شماره تلفن همراه یکسان باشد.
            </li>
          </ul>
          <div></div>
        </Hint>
      </div>
    </div>
  );
}
